import { PropsWithChildren } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { wagmiConfig } from 'shared/config/wagmi';
import { WagmiProvider } from 'wagmi';

const queryClient = new QueryClient();

export const WithWagmi = ({ children }: PropsWithChildren) => {
  return (
    <QueryClientProvider client={queryClient}>
      <WagmiProvider config={wagmiConfig} reconnectOnMount={false}>
        {children}
      </WagmiProvider>
    </QueryClientProvider>
  );
};
